import Navbar from '../components/Navbar'

import Form from '../components/Form/Form'

import { formData, sendInfo } from '../data/directorFormData'
import { directorAnalysis } from '../helpers/analysis'

const DirectorForm = () => {
    return (
        <div className="background">
            <Navbar />
            <Form formData={formData} sendInfo={sendInfo} analysis={directorAnalysis} />
        </div>
    )
}

export default DirectorForm